import { useState, useEffect } from "react";

const useAbortController = () => {
  const [abortController, setAbortController] = useState(null);

  const createAbortController = () => {
    // If there's an existing controller, abort the previous request
    if (abortController) {
      abortController.abort();
    }
    // Create and set a new AbortController
    const newAbortController = new AbortController();
    setAbortController(newAbortController);
    return newAbortController;
  };

  useEffect(() => {
    // Cleanup function to abort the ongoing request on unmount
    return () => {
      if (abortController) {
        abortController.abort();
      }
    };
  }, [abortController]);

  return { createAbortController, signal: abortController?.signal };
};

export default useAbortController;
